module.exports = __webpack_public_path__ + "static/media/villaraigosa.46717e03.webp";


//////////////////
// WEBPACK FOOTER
// ./src/pages/june-5/races/images/villaraigosa.webp
// module id = 688
// module chunks = 40 46